export default __webpack_public_path__ + "static/media/logistar-big.77912db8.png";